"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    enabledBackground: "new 0 0 24 24",
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "#004864"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "m12.4 8.2h-1.2v3.7h.9c.6 0 1.3-.1 1.8-.5.4-.3.6-.9.6-1.4s-.1-1-.5-1.3c-.5-.4-1-.6-1.6-.5z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m23.2 0h-22.4c-.4 0-.8.4-.8.8v22.3c0 .5.4.9.8.9h22.3c.5 0 .8-.4.8-.8v-22.4c.1-.4-.3-.8-.7-.8zm-7.4 12.9c-1 .7-2.3 1.1-3.5 1h-1.1v4.3h-2.6v-12.1h3.9c1.2-.1 2.4.3 3.4 1 .8.7 1.2 1.7 1.1 2.8 0 1.2-.4 2.2-1.2 3z"
  })));
};

exports["default"] = _default;